import { queryOptions } from '@tanstack/react-query';

import { dashboardApi } from '../api/dashboard.api';

import { Filters, Globals } from '@data-access';

export const dashboardQueries = (global: Globals) => ({
  all: () => [global, 'dashboard'],
  news: () =>
    queryOptions({
      queryKey: ['news'],
      queryFn: () => dashboardApi.news(),
    }),
  campaignStats: () =>
    queryOptions({
      queryKey: [...dashboardQueries(global).all(), 'campaignStats'],
      queryFn: () => dashboardApi.getCampaignStats(),
    }),
  adminStats: (filters: Filters) =>
    queryOptions({
      queryKey: [...dashboardQueries(global).all(), 'admin', filters],
      queryFn: () => dashboardApi.getAdminStats(filters),
    }),

  synthesis: (filters: Filters) =>
    queryOptions({
      queryKey: [...dashboardQueries(global).all(), 'synthesis', filters],
      queryFn: () => dashboardApi.getSynthesis(filters),
    }),
});
